import { jsxs as m, jsx as o } from "react/jsx-runtime";
import j from "clsx";
import { useId as y } from "react";
import { useIcon as h } from "./use-icon.hook.js";
import { useSvg as u } from "./use-svg.hook.js";
import '../../assets/icon.css';const g = "_icon_mynjf_1", x = "_icon__host_mynjf_80", z = "_icon__mask_mynjf_92", n = {
  icon: g,
  "icon--ratio-1": "_icon--ratio-1_mynjf_17",
  "icon--ratio-075": "_icon--ratio-075_mynjf_21",
  "icon--ratio-05": "_icon--ratio-05_mynjf_25",
  "icon--color-success": "_icon--color-success_mynjf_29",
  "icon--color-error": "_icon--color-error_mynjf_33",
  "icon--color-warning": "_icon--color-warning_mynjf_37",
  "icon--color-info": "_icon--color-info_mynjf_41",
  "icon--size-sm": "_icon--size-sm_mynjf_45",
  "icon--size-md": "_icon--size-md_mynjf_49",
  "icon--size-lg": "_icon--size-lg_mynjf_53",
  "icon--size-xl": "_icon--size-xl_mynjf_57",
  "icon--size-2xl": "_icon--size-2xl_mynjf_61",
  "icon--size-3xl": "_icon--size-3xl_mynjf_65",
  "icon--size-inherit": "_icon--size-inherit_mynjf_69",
  icon__host: x,
  icon__mask: z,
  "icon--color-light": "_icon--color-light_mynjf_108",
  "icon--color-dark": "_icon--color-dark_mynjf_112",
  "icon--color-inherit": "_icon--color-inherit_mynjf_116",
  "icon--justify-start": "_icon--justify-start_mynjf_120",
  "icon--justify-center": "_icon--justify-center_mynjf_124",
  "icon--justify-end": "_icon--justify-end_mynjf_128",
  "icon--color-volt": "_icon--color-volt_mynjf_154",
  "icon__hidden-gradient": "_icon__hidden-gradient_mynjf_154"
}, N = ({
  icon: t,
  size: c = "md",
  ratio: _ = 0.75,
  color: i,
  title: f,
  justify: r,
  className: a = "",
  ...d
}) => {
  if (!t)
    throw new Error("Icon is undefined");
  const e = y(), s = h(t), l = u(s, f);
  return /* @__PURE__ */ m(
    "span",
    {
      className: j(
        {
          [n.icon]: !0,
          [n["icon--ratio-1"]]: _ === 1,
          [n["icon--ratio-075"]]: _ === 0.75,
          [n["icon--ratio-05"]]: _ === 0.5,
          [n["icon--size-sm"]]: c === "sm",
          [n["icon--size-md"]]: c === "md",
          [n["icon--size-lg"]]: c === "lg",
          [n["icon--size-xl"]]: c === "xl",
          [n["icon--size-2xl"]]: c === "2xl",
          [n["icon--size-3xl"]]: c === "3xl",
          [n["icon--size-inherit"]]: c === "inherit",
          [n["icon--color-success"]]: i === "success",
          [n["icon--color-error"]]: i === "error",
          [n["icon--color-warning"]]: i === "warning",
          [n["icon--color-info"]]: i === "info",
          [n["icon--color-light"]]: i === "light",
          [n["icon--color-dark"]]: i === "dark",
          [n["icon--color-inherit"]]: i === "inherit",
          [n["icon--color-inherit"]]: i === "inherit",
          [n["icon--color-volt"]]: i === "volt",
          [n["icon--justify-start"]]: r === "start",
          [n["icon--justify-center"]]: r === "center",
          [n["icon--justify-end"]]: r === "end"
        },
        a
      ),
      "data-testid": "icon-container",
      ...d,
      children: [
        i === "volt" ? (
          // SVG layer exists as a reference for a gradient type (volt only for now)
          /* @__PURE__ */ o("svg", { className: n["icon__hidden-gradient"], children: /* @__PURE__ */ o("defs", { children: /* @__PURE__ */ m("linearGradient", { id: e, children: [
            /* @__PURE__ */ o("stop", { offset: "0.1" }),
            /* @__PURE__ */ o("stop", { offset: "0.545" }),
            /* @__PURE__ */ o("stop", { offset: "0.9" })
          ] }) }) })
        ) : null,
        l && /* @__PURE__ */ o(
          "span",
          {
            className: n.icon__host,
            style: {
              "--icon-gradient-url": `url(#${e})`
            },
            children: l
          }
        ),
        s.url && /* @__PURE__ */ o("span", { className: n.icon__host, children: /* @__PURE__ */ o(
          "span",
          {
            className: n.icon__mask,
            style: { "--_maskUrl": s.url }
          }
        ) })
      ]
    }
  );
};
export {
  N as Icon
};
